import React, { useContext } from 'react';
import './styles.css';
import P from 'prop-types';
import { GlobalContext } from '../../contexts/HomeContext';
import { Capitalize } from '../../utils/utils';

export const DetalhesListGroup = ({ items, isPizzaFracao, children }) => {
  const { dadosApp } = useContext(GlobalContext);
  const data = items;
  // testar quantidade máxima = 0
  let adicionalDescricao = `Opcional`;
  if (data[0].QtdMaxima === 1) {
    adicionalDescricao = `Escolha até ${data[0].QtdMaxima} opção`;
  } else if (data[0].QtdMaxima > 1) {
    adicionalDescricao = `Escolha até ${data[0].QtdMaxima} opções`;
  }

  let qtdeSelecionada = 0;
  let qtdeObrigatoria = 0;
  //let qtdMaxima = 0;
  let complete = false;

  // valida se aquele grupo esta completo
  if (data[0].TipoMontagem === 'OBRIGATORIO' || data[0].TipoMontagem === 'COMBO') {
    qtdeObrigatoria = data[0].QtdeObrigatoria;
    data.map((item) => {
      if (item.Produto.quantidade !== undefined) {
        qtdeSelecionada += item.Produto.quantidade;
      }
    });
    if (qtdeSelecionada >= qtdeObrigatoria) complete = true;
  }
  if (data[0].TipoMontagem === 'ADICIONAL' || data[0].TipoMontagem === 'PIZZA') {
    // qtdMaxima = data[0].QtdMaxima;
    // data.map((item) => {
    //   if (item.Produto.quantidade !== undefined) {
    //     qtdeSelecionada += item.Produto.quantidade;
    //   }
    // });
    //if (qtdeSelecionada <= qtdMaxima) complete = true;
    complete = true;
  }

  //if (qtdeSelecionada >= qtdeObrigatoria) complete = true;

  return (
    <>
      <div
        className="group_container"
        style={{ top: isPizzaFracao ? '61px' : '0', borderBottom: complete ? '2px solid #50a773' : '2px solid red' }}
      >
        <span className="group_title_content">
          <p className="group_title capitalize">
            {data[0].Titulo.toLowerCase()}
            {data[0].TipoMontagem === 'ADICIONAL' && (
              <span className="group_title_desc" style={{ textTransform: 'none' }}>
                {adicionalDescricao}
              </span>
            )}
            {data[0].TipoMontagem === 'PIZZA' && (
              <span className="group_title_desc">{`* Cobrança da Pizza pela ${Capitalize(
                dadosApp.Empresa.Config.pizza_cobranca.replace('MEDIA', 'Média'),
              )}`}</span>
            )}
            {data[0].TipoMontagem === 'OBRIGATORIO' && (
              <span className="group_title_desc">Escolha {data[0].QtdeObrigatoria}</span>
            )}
            {data[0].TipoMontagem === 'COMBO' && (
              <span className="group_title_desc">Escolha {data[0].QtdeObrigatoria}</span>
            )}
          </p>

          {!complete && data[0].TipoMontagem !== 'ADICIONAL' && <p className="group_title">Obrigatório</p>}
          {/* {complete && data[0].TipoMontagem !== 'ADICIONAL' && ( */}
          {complete && (
            <i id={'group' + data[0].Titulo} className={`material-icons ${complete ? 'check_complete' : ''}`}>
              check
            </i>
          )}

          {/* {data[0].TipoMontagem === 'ADICIONAL' && <i className="material-icons check_complete"> check</i>} */}
        </span>
      </div>
      <div>{children}</div>
    </>
  );
};

DetalhesListGroup.propTypes = {
  items: P.array,
  isPizzaFracao: P.bool,
  children: P.array,
  //children: React.ReactNode,
};
